import { render, staticRenderFns } from "./UserRightsOverview.vue?vue&type=template&id=4daf7d3a&scoped=true"
import script from "./UserRightsOverview.vue?vue&type=script&lang=js"
export * from "./UserRightsOverview.vue?vue&type=script&lang=js"
import style0 from "./UserRightsOverview.vue?vue&type=style&index=0&id=4daf7d3a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4daf7d3a",
  null
  
)

export default component.exports